import React, { useEffect, useState, useCallback } from "react";
import Header from "../components/Header";
import { Link , useLocation ,useParams } from "react-router-dom";
import Nodata from "../components/NoData";
import Star from "../components/Star";
import ProdList from "../components/ProdList";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import ImageViewer from 'react-simple-image-viewer';

export default function ProductReview() {
    const { t } = useTranslation();

    let {id} = useParams();
    const lang = localStorage.getItem("language") || "ko";
    const [request] = useAxios();
    const [isOpen, setOpen] = useState(false);
    const [data, setData] = useState({});
    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(0);
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [imgList, setImgList] = useState([]);

    const fn_clickImg = useCallback((list,index) => {      
        let tempList = [];
        list.forEach(function (value, index) {
            tempList.push("https://www.salee.co.kr/com/cmm/getGoodsBbsNttImage.sale?bbsSn=3&atchmnflSn="+value.atchmnflSn)
        });
        setImgList(tempList)
        setCurrentImage(index);
        setIsViewerOpen(true);
      }, []);
    
      const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
      };


    const fetchData = async () => {

        const response = await request.post("/app/goods/getGoodsDetailAPI", {
            nationSeCode : lang,
            goodsSn : id
        });
        if(response.data.resultCode === 200){            
            setData(response.data.result);
        }       
    };

    const fetchData2 = async (pageIndex) => {
        
        const response = await request.post("/app/goods/getGoodsNttListAPI", {            
            bbsSn : 3,
            searchKrwd :id,
            searchCnd : 'aditfield1',
            pageIndex : pageIndex

        });
        if(response.data.resultCode === 200){           
               
          
            setDataList((prevData) => [...prevData, ...response.data.result.resultList]);
        }            
    };

    useEffect(() => {
        fetchData();
      }, []);

      useEffect(() => {    
        if(page > 0){
            fetchData2(page);    
        }
      }, [page]);

      
  const handleObserver = (entries) => {
    const target = entries[0];
    if (target.isIntersecting ) {
        setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      threshold: 0, //  Intersection Observer의 옵션, 0일 때는 교차점이 한 번만 발생해도 실행, 1은 모든 영역이 교차해야 콜백 함수가 실행.
    });
    // 최하단 요소를 관찰 대상으로 지정함
    const observerTarget = document.getElementById("observer");
    // 관찰 시작
    if (observerTarget) {
      observer.observe(observerTarget);
    }
  }, []);

    return(

        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue">
                <Header type="cart" pageTitle={data.goodsInfoVO && data.goodsInfoVO.goodsNm}/>
                <div className="tabArea">
                    <Link to={"/ProductDetail/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title1`)}</Link>
                    <Link to={"/ProductBuyInfo/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title2`)}</Link>
                    <Link className="tabBtn active">{t(`Message.goods_detail_screen_tab_title3`)} {data.goodsReviewCnt && data.goodsReviewCnt}</Link>
                    <Link to={"/ProductQnA/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title4`)} {data.goodsInqryCnt && data.goodsInqryCnt}</Link>
                </div>
            </div>


            <div className="hdTabContWr">

                {dataList && dataList.length === 0?(
                <div className="floatCenter">
                    <Nodata text={t(`Message.goods_review_list_empty_msg`)}/>
                </div> 
                ):(
                <>
                <div className="totalWr">
                    <p>{t(`Message.goods_review_list_title`)} <span>{t(`Message.goods_review_list_tot_cnt` , {resultCnt : data.goodsReviewCnt && data.goodsReviewCnt})}</span></p>
                    <Star type="star1" obj={data.goodsInfoVO} />
                </div>

                
                <div className="rvListWr">
                    {dataList && dataList.map((obj, index) => (
                    <div className="rvArea" key={index}>
                        <h3 className="userId">{obj.frstRegisterId}</h3>
                        <div className="dfcsG12 mb8">
                            <Star type="long" grad0={!obj.aditfield3}  
                                grad1={(obj.aditfield3 ==="1")}  
                                grad2={(obj.aditfield3 ==="2")}
                                grad3={(obj.aditfield3 ==="3")}
                                grad4={(obj.aditfield3 ==="4")}
                                grad5={(obj.aditfield3 ==="5")}
                             num={obj.aditfield3}/>
                            <p className="date">{obj.frstRegistPnttm}</p>
                        </div>
                        <div className="optionWr">
                            <p className="option">{obj.firstOptnNm}</p>
                            <p className="option">{obj.firstOptnValue}</p>
                        </div>
                        <p className="rvCont">{obj.nttCn}</p>
                        <div className="imgWr">
                        {obj.atchmnflList && obj.atchmnflList.map((file, index2) => (
                                <div key={index2}>
                                    {file.atchmnflSn?(
                                     <img onClick={ () => fn_clickImg(obj.atchmnflList,index2)  } src={"https://www.salee.co.kr/com/cmm/getGoodsBbsNttImage.sale?bbsSn=3&atchmnflSn="+file.atchmnflSn} alt={"첨부이미지"+index} />
                                ):null}
                                </div>
                            ))}                                                                  
                        </div>
                    </div>
                    ))}     
                </div>
                </>
                )}
                <div id="observer" style={{ height: "10px" }}></div>

                {isViewerOpen && (
                    <ImageViewer
                    src={ imgList }
                    currentIndex={ currentImage }
                    disableScroll={ false }
                    closeOnClickOutside={ true }
                    onClose={ closeImageViewer }
                    />
                )}

                <div className="bottomBtnWr">
                    <button 
                        type="button" 
                        className="btn48 cFFF orgB"
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation(); 
                            setOpen(true);
                        }}>
                        {t(`Message.bottom_navigation_bar_order_btn`)}
                    </button>
                </div>

                <ProdList id={id} prodOpen={isOpen} setProdOpen={setOpen}></ProdList>
            </div>
        </div>
    );
};